import i18n from "i18n";
const SidebarEventDetails = (alertId, definitionId) => ({
  id: "alert-event-details",
  title: i18n.t("alerts_replay.details_title", { ns: "events" }),
  componentKey: "replay-search-sidebar",
  props: { alertId, definitionId }
});
export default SidebarEventDetails;
